module.exports = __webpack_public_path__ + "img/yua.3ec0ef90.svg";